<template>
  <v-flex
    xs12
    md8
  >
    <v-card class="pa-5">
      <v-form>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Titolo"
                prepend-icon="mdi-star"
                v-model="profile.title"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Avatar"
                prepend-icon="mdi-image"
                v-model="profile.avatar"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Sito Web"
                prepend-icon="mdi-earth"
                v-model="profile.website"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="LinkedIn"
                prepend-icon="mdi-linkedin"
                v-model="profile.linkedin"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Facebook"
                prepend-icon="mdi-facebook-box"
                v-model="profile.facebook"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Instagram"
                prepend-icon="mdi-instagram"
                v-model="profile.instagram"
              />
            </v-flex>

            <v-flex xs12>
              <v-textarea
                ref="bio"
                :class="{'length-error': length}"
                label="Bio"
                prepend-icon="mdi-comment-text-outline"
                v-model="profile.bio"
                counter="512"
              />
            </v-flex>
            <v-flex
              xs12
              text-xs-right
            >
              <v-btn
                class="mx-0"
                color="primary"
                block
                @click="update"
              >
                Aggiorna Profilo
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

  </v-flex>
</template>

<script>
  export default {
    name: 'ProfileForm',
    props: {
      profile: { type: Object },
      update: { type: Function }
    },
    data() {
      return {
        length: false,
      }
    },
    watch: {
      profile: {
        handler(val) {
          if (val.bio && val.bio.length > 512) {
            this.length = true
          } else {
            this.length = false
          }
        },
        deep: true,
      }
    },
  }
</script>

<style scoped>
  .length-error .v-input__control .v-text-field__details .v-counter {
    color: red;
  }
</style>